import { useLocation, useNavigate } from 'react-router-dom';
import classNames from 'classnames/bind';
import dayjs from 'dayjs';

import { generateModulePath, timeFormatter } from '@autopass-web/domain';

import { analytics } from '../../app-loader';
import useAppStore from '../../app-store';
import { PROMOTION_LIST } from '../../config';
import {
  Between1to7DatesMatcher,
  ComingSoonMatcher,
  In24HoursMatcher,
  isFromPromotionBoard,
  openUrl,
  PromotionFullMatcher,
} from '../../helper';
import { PromotionLoading } from '../loading';
import UserUsageStatusTag from '../user-usage-status-tag';
import styles from './index.module.scss';
const cx = classNames.bind(styles);
const duration = require('dayjs/plugin/duration');
dayjs.extend(duration);

export const PromotionItems = ({ promotions, loading, filterBy }) => {
  const location = useLocation();
  const appStore = useAppStore();
  const navigate = useNavigate();
  const generatePath = generateModulePath(
    appStore.nextModule,
    appStore.basePath,
  );

  const Items = () => {
    const convertPromotionToDisplay = (promotion) => {
      if (isFromPromotionBoard(promotion)) {
        return {
          onClick: () => openUrl(promotion.attributes.url),
          name: promotion.attributes.title,
          tag: promotion.attributes.tag,
          label: '特選推薦',
          image: promotion.attributes.imageUrl,
        };
      } else {
        return {
          onClick: () => navigate(generatePath(`/detail/${promotion.id}`)),
          name: promotion.name,
          type: promotion.type,
          tag: promotion.badageLabel,
          label: promotionLabel(promotion),
          image: promotion.imageUrl,
          userUsageStatus: promotion.userUsageStatus,
        };
      }
    };

    if (loading) {
      return (
        <>
          <PromotionLoading />
          <PromotionLoading />
          <PromotionLoading />
          <PromotionLoading />
        </>
      );
    }

    if (promotions.length === 0) {
      return window.location.pathname === '/promotion' ? (
        <div className={styles['empty-view']}>
          {filterBy
            ? `${PROMOTION_LIST[filterBy].name}優惠即將上線`
            : '優惠即將上線'}
          <br />
          麻吉們再稍等一下
        </div>
      ) : null;
    }

    return promotions.map((p) => {
      const promotionItemData = convertPromotionToDisplay(p);

      return (
        <div
          key={p.id}
          className={styles['promotion-item']}
          onClick={() => {
            analytics.promotion_item_onClick({
              id: p.id,
              name: promotionItemData.name,
              type: promotionItemData.type,
              url: promotionItemData.url,
              source: location.pathname.includes('group')
                ? 'promotion_collection'
                : 'promotion_list',
            });
            promotionItemData.onClick();
          }}
        >
          <div className={styles.info}>
            <div className={styles.tags}>
              <span className={styles.tag}>{promotionItemData.tag}</span>
              <UserUsageStatusTag
                counts={
                  promotionItemData.userUsageStatus
                    ? {
                        refueling:
                          promotionItemData.userUsageStatus[
                            'RefuelingPromotion'
                          ],
                        parking:
                          promotionItemData.userUsageStatus['ParkingPromotion'],
                        onStreetParking:
                          promotionItemData.userUsageStatus[
                            'OnStreetParkingPromotion'
                          ],
                      }
                    : {}
                }
              />
            </div>
            <div className={styles.title}>{promotionItemData.name}</div>
            <div className={styles.label}>{promotionItemData.label}</div>
          </div>
          <div
            className={styles.image}
            style={{
              backgroundImage: `url(${
                promotionItemData.image || '/assets/img-list.jpg'
              })`,
            }}
          />
        </div>
      );
    });
  };

  // 時間標籤
  const promotionLabel = (promotion) => {
    const endAt = dayjs(promotion.endAt);
    const now = dayjs();
    const duration = dayjs.duration(endAt.diff(now));

    const matchers = [
      new PromotionFullMatcher(promotion.usagePercentage),
      new ComingSoonMatcher(promotion.startAt),
      new In24HoursMatcher(duration),
      new Between1to7DatesMatcher(duration),
    ];

    const matcher = matchers.find((m) => m.isMatch());

    let label = '';
    if (matcher === undefined) {
      const endAt = timeFormatter(promotion.endAt, 'date');
      label = `${endAt} 止`;
    } else {
      label = matcher.getLabel();
    }

    const labelClass = cx({
      label: true,
      comingSoon: matcher && matcher.getPromotionLabel() === 'ComingSoon',
    });

    return <div className={labelClass}>{label}</div>;
  };

  return (
    <div className={styles['items-container']}>
      <Items />
    </div>
  );
};
